var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"src":_vm.videoEmbedUrl,"width":_vm.width,"height":"300","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }